import { RemoteClients } from '../../../data/usecases/clients/clients'
import { makeAxiosHttpClient } from '../../factories/http/axios-http-client-factory-no-redirect'

export const makeRemoteClients = ():any => new RemoteClients('/cliente', makeAxiosHttpClient())

export const makeRemoteClientsClassificications = ():any => new RemoteClients('/cliente/classificacao', makeAxiosHttpClient())

export const makeRemoteClientsManagers = ():any => new RemoteClients('/cliente/manager', makeAxiosHttpClient())
